<template>
    <v-menu offset-y :nudge-width="100">
        <v-toolbar-title  slot="activator" :title="$t('LangSwitcher.Tooltip')" >
          <flag :squared="false" :iso="currentLocale" :title="$t('LangSwitcher.Tooltip')"  />          
          <v-icon dark>mdi-menu-down</v-icon>
        </v-toolbar-title>
        <v-list>
          <v-list-tile v-for="locale in locales" :key="locale.code" @click="setLang(locale.code)">
              <v-list-tile-avatar><flag :squared="false" :iso="getFlagCode(locale.code)" /></v-list-tile-avatar>
            <v-list-tile-title v-text="locale.name"></v-list-tile-title>
          </v-list-tile>
        </v-list>
    </v-menu>  
</template>
<script>
  import {loadLanguageAsync,locales} from '@/locale/vueI18n'  
  export default {
    name: 'LangSwitcher',
   computed: {
      currentLocale() {
        return this.getFlagCode(this.$i18n.locale)
      },
      locales() {
        return locales
      }
    },
    methods: {   
      getFlagCode(locale){
        return locale == 'en'?'gb':locale
      },
      setLang(lang) {
        loadLanguageAsync(lang)
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>  
</style>
